<div class="thank-you-page">
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
    <div class="thank-you-message">
        <h1 style="font-size: 5rem; color: white;">Thank you</h1>
    </div>
    <div class="thank-you-details">
        <p style="font-size: 1.5rem; color: white;">Thank you for getting in touch with us!</p>
        <p style="font-size: 1.5rem; color: white;">We truly appreciate your interest in our services.</p>
        <p style="font-size: 1.5rem; color: white;">Your time is important, and we want you to know that your message has been received. Our team is reviewing it and will get back to you as soon as possible.</p>
        <p style="font-size: 1.5rem; color: white;">If your inquiry is urgent or you require immediate assistance, please feel free to reach out to our support team directly at <a href="mailto:enquiry@superiorsystems.in">enquiry&#64;superiorsystems.in</a> or give us a call at <a href="tel:+918023116047">+91 80 2311 6047</a>.</p>
        <p style="font-size: 1.5rem; color: white;">Thank you once again for contacting us. We look forward to the opportunity to assist you and provide the support you need.</p>
    </div>
</div>
    <div class="navigate-home">
        <button onclick="window.location.href='/'" class="btn_home">
            Go to Home Page
        </button>
    </div>
</div>

